<template>
  <div class="irp-partner-score-cell">
    <PartnerScoreTag v-if="partner" :partner="partner" :with-breakdown="true" />
    <span v-else class="irp-partner-score-cell__empty">&mdash;</span>
  </div>
</template>

<script setup lang="ts">
import type { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import PartnerScoreTag from '@/components/partners/PartnerScoreTag.vue';

import { usePartnersStore } from '@/stores';
import type { RecordOverviewPartnerType } from '@/types/individual_record';

const { params } = defineProps<{
  params: ICellRendererParams<RecordOverviewPartnerType>;
}>();

const partnersStore = usePartnersStore();

const partner = computed(() =>
  partnersStore.getPartnerOrgByUuid(
    params.data?.partner_organization_uuid ?? '',
  ),
);
</script>

<style lang="pcss">
@reference "../../../css/theme.css";
.irp-partner-score-cell {
  @apply flex items-center h-full w-full;
}

.irp-partner-score-cell__empty {
  @apply text-neutral-text-weak;
}
</style>
